module.exports = __webpack_public_path__ + "img/7.98c2e60d.png";